
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { useSelector } from "react-redux";
import { DocumentLoading_State } from "../../shared/enums";

import { reduxActions, RootState } from "../../store";
import { store } from "../..";

import CircleLoader from "../Loader/CircleLoader/CircleLoader";
import './PdfViewer.scss';

pdfjs.GlobalWorkerOptions.workerSrc = 'pdf.worker.min.js';

export interface PreviewProps {
    base64String?: string | undefined
    // initialLoading deve essere true quando si vuole evitare di vedere il NoData finch� 
    // non arriva la response che restituisce la stringa base64
    // (es. in protocolViewer finch� non viene caricato la stringa base64 del documento)
    initialLoading: boolean
    onLoadDocumentError?: () => void
}

type Props = PreviewProps;


const PdfViewer: React.FunctionComponent<Props> = props => {

    //pdfjs.GlobalWorkerOptions.workerSrc = process.env.PUBLIC_URL + '/pdf.worker.min.js';


    const [currentBase64String, setCurrentBase64String] = useState<string | undefined>(undefined);
    const [pageScale, setPageScale] = useState(1);
    const [numPages, setNumPages] = useState(null);
    const [documentLoadingState, setDocumentLoading] = useState<DocumentLoading_State>(DocumentLoading_State.Loading);

    const selectCurrentState = (state: RootState) => state.protocolWizardReducer;
    const protocolWizardState = useSelector(selectCurrentState);

    useEffect(() => {
        if (props.base64String) {
            setDocumentLoading(DocumentLoading_State.Loading);
            setCurrentBase64String('data:application/pdf;base64,' + props.base64String)
        }
        else if (props.initialLoading && !props.base64String) {
            setDocumentLoading(DocumentLoading_State.Loading);
        }
        else {
            setDocumentLoading(DocumentLoading_State.NoData);
            setCurrentBase64String(undefined)
        }
    }, [props.base64String]);

    function onLoadDocumentSuccess(pdf) {
        setNumPages(pdf.numPages);
        setDocumentLoading(DocumentLoading_State.LoadSuccess);

        let { protocol } = protocolWizardState;

        if (protocol.fields) {
            let fields = [...protocol.fields];
            let numPagineFieldIndex = fields.findIndex(f => f.internalName === 'PagineDocumento');
            if (numPagineFieldIndex !== -1) {
                let numPagineField = { ...fields[numPagineFieldIndex] };
                numPagineField.internalValue = pdf.numPages
                fields[numPagineFieldIndex] = numPagineField;
                protocol.fields = [...fields];
                store.dispatch(reduxActions
                    .protocolWizardActions
                    .updateProtocolWizardState({
                        ...protocolWizardState,
                        ...protocol
                    })
                );
            }
        }
    }
    function onLoadDocumentError(error) {
        console.error(error.message);
        setDocumentLoading(DocumentLoading_State.LoadError);
        if (props.onLoadDocumentError)
            props.onLoadDocumentError();

    }

    const onPageLoad = (page) => {
        if (page._pageIndex == 0) {
            /// calcolo lo scale del documento
            let pdfContainerWidth = document.getElementsByClassName('react-pdf__Page')[0]?.clientWidth;
            let scale = pdfContainerWidth / page.originalWidth
            scale = scale < 1.5 ? scale : 1.5;
            setPageScale(scale);
        }
    }



    return (
        <div style={{ position: 'relative', height: '100%', minHeight: '300px' }}>
            <CircleLoader loaderClass='loader-large' loading={documentLoadingState === DocumentLoading_State.Loading} />

            {(documentLoadingState !== DocumentLoading_State.LoadError) &&
                <Document
                    file={currentBase64String}
                    onLoadSuccess={onLoadDocumentSuccess}
                    onLoadError={onLoadDocumentError}
                >
                    {Array.from(new Array(numPages), (el, index) => (
                        <Page
                            key={`page_${index + 1}`}
                            pageNumber={index + 1}
                            onLoadSuccess={onPageLoad}
                            scale={pageScale}
                        />
                    ))}
                </Document>
            }
            {(documentLoadingState === DocumentLoading_State.LoadError) &&
                <div className="preview-document">
                    <div className="preview-document-container">
                        <FontAwesomeIcon className="preview-document-icon" icon={{ prefix: 'far', iconName: 'eye-slash' }} />
                    </div>
                    <h2 className="preview-document-description">Anteprima non disponibile</h2>
                </div >
            }
            {(documentLoadingState === DocumentLoading_State.NoData) &&
                <div className="preview-document">
                    <div className="preview-document-container">
                        <FontAwesomeIcon className="preview-document-icon" icon={{ prefix: 'far', iconName: 'file' }} />
                    </div>
                    <h2 className="preview-document-description">Nessun documento selezionato</h2>
                </div >
            }

        </div>
    );
}

export default PdfViewer;